import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { db } from '../firebaseConfig/firebase';
import { collection, query, where, getDocs, doc, writeBatch } from "firebase/firestore";
import { Form, Alert, ProgressBar, Container } from 'react-bootstrap';

// Import Header si lo necesitas usar en el return, de momento lo mantengo importado
import Header from './Header';

function UpdatePort() {
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState({ type: '', msg: '' });
    const [progress, setProgress] = useState(0);

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setLoading(true);
        setStatus({ type: 'info', msg: 'Procesando archivo...' });
        setProgress(0);

        const reader = new FileReader();
        reader.onload = async (event) => {
            try {
                const data = event.target.result;
                const workbook = XLSX.read(data, { type: 'binary' });
                const sheetName = workbook.SheetNames[0];
                const excelData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

                await updateDatabase(excelData);
            } catch (error) {
                console.error(error);
                setStatus({ type: 'danger', msg: 'Error al leer el Excel' });
                setLoading(false);
            }
        };
        reader.readAsBinaryString(file);
    };

    const updateDatabase = async (data) => {
        let actualizados = 0;
        let errores = 0;

        // Batch para agrupar actualizaciones (máximo 500 por lote)
        let batch = writeBatch(db);
        let count = 0;

        for (let i = 0; i < data.length; i++) {
            const fila = data[i];
            const email = fila.EMAIL_ALUMNO?.trim();
            const nuevoPortafolio = fila.PORTFOLI_UPDATE;
            const nuevosComentarios = fila.COMENTARIOS; // <-- NUEVO: Capturamos COMENTARIOS

            if (!email) continue;

            try {
                const q = query(collection(db, "tribu-esp"), where("EMAIL_ALUMNO", "==", email));
                const querySnapshot = await getDocs(q);

                if (!querySnapshot.empty) {
                    for (const documento of querySnapshot.docs) {
                        const docRef = doc(db, "tribu-esp", documento.id);

                        // <-- NUEVO: Añadimos COMENTARIOS al update (manejando si viene vacío)
                        batch.update(docRef, { 
                            PORTFOLI_UPDATE: String(nuevoPortafolio),
                            COMENTARIOS: nuevosComentarios !== undefined ? String(nuevosComentarios) : "" 
                        });

                        actualizados++;
                        count++;

                        // Si el batch se llena dentro del bucle de documentos, lo enviamos
                        if (count >= 400) {
                            await batch.commit();
                            batch = writeBatch(db);
                            count = 0;
                        }
                    }
                } else {
                    console.warn(`No se encontró alumno con email: ${email}`);
                    errores++;
                }
            } catch (err) {
                console.error("Error en fila:", i, err);
                errores++;
            }

            setProgress(Math.round(((i + 1) / data.length) * 100));
        }

        // Ejecutar las operaciones restantes
        if (count > 0) {
            await batch.commit();
        }

        setStatus({
            type: 'success',
            msg: `Proceso terminado. Actualizados: ${actualizados}. No encontrados: ${errores}`
        });
        setLoading(false);
    };

    return (
        <>
            <Header />
            <Container>
                <div className="p-4 border rounded bg-light mt-4">
                    <h5>Actualizar Portafolio mediante Excel</h5>
                    <p className="small text-muted">
                        {/* <-- NUEVO: Actualizado el texto para reflejar la nueva columna */}
                        El Excel debe tener las columnas: <strong>EMAIL_ALUMNO</strong>, <strong>PORTFOLI_UPDATE</strong> y <strong>COMENTARIOS</strong>
                    </p>

                    <Form.Group className="mb-3">
                        <Form.Control
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileUpload}
                            disabled={loading}
                        />
                    </Form.Group>

                    {loading && (
                        <div className="mb-3">
                            <p className="small mb-1">Actualizando base de datos... {progress}%</p>
                            <ProgressBar animated now={progress} />
                        </div>
                    )}

                    {status.msg && <Alert variant={status.type}>{status.msg}</Alert>}
                </div>
            </Container>
        </>
    );
}

export default UpdatePort;